var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 11,
    viewBox: "0 0 6 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.08985 0.339843C5.3112 0.339843 5.50651 0.417968 5.67578 0.574218C5.83203 0.743489 5.91016 0.938801 5.91016 1.16016C5.91016 1.27734 5.89063 1.38802 5.85156 1.49219C5.8125 1.59635 5.75391 1.68099 5.67578 1.74609L2.10156 5.33984L5.67578 8.91406C5.74089 8.99219 5.79948 9.07682 5.85156 9.16797C5.89063 9.27213 5.91016 9.3763 5.91016 9.48047C5.91016 9.71484 5.83203 9.91016 5.67578 10.0664C5.50651 10.2357 5.30469 10.3203 5.07031 10.3203C4.96615 10.3203 4.86198 10.3008 4.75781 10.2617C4.65365 10.2227 4.5625 10.1641 4.48438 10.0859L0.32422 5.92578C0.246095 5.84766 0.187501 5.75651 0.148438 5.65234C0.109376 5.5612 0.0898447 5.45703 0.0898447 5.33984C0.0898447 5.22266 0.109376 5.11198 0.148438 5.00781C0.187501 4.90364 0.246095 4.81901 0.32422 4.75391L4.50391 0.574218C4.56901 0.496093 4.65365 0.437499 4.75781 0.398437C4.86198 0.359374 4.97266 0.339843 5.08985 0.339843Z",
    fill: "#526484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationArrow);
export default __webpack_public_path__ + "static/media/navigation-arrow.90291ab856a7376918653d66343140c2.svg";
export { ForwardRef as ReactComponent };